<section class="main">
    <div
        *ngFor="let question of selectedQuestions"
        [ngModelGroup]="question.field"
    >
        <my-health-admin-question
            [question]="question"
            [customerId]="customerId"
            [data]="data[question.field]"
            [allAnswers]="data"
            [editMode]="editMode"
            [brand]="brand"
        ></my-health-admin-question>
    </div>
</section>
